import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type MutationProps = {
	companyId: string;
};

const useGetWhitelistedDomainsMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId }: MutationProps) => {
			return agentOfficeSetupService.getWhitelistedDomains({ companyId });
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGetWhitelistedDomainsMutation;
